'use client'

import { useEffect } from 'react'
import { useBlogCategory } from '@/context/BlogCategoryContext'

export default function CategoryPageClient({ categorySlug, children }) {
  const { setBlogCategory } = useBlogCategory()

  useEffect(() => {
    if (categorySlug) {
      setBlogCategory(categorySlug)
    }
    
    // Очищаем категорию при размонтировании компонента
    return () => {
      setBlogCategory(null)
    }
  }, [categorySlug, setBlogCategory])

  return <>{children}</>
} 